// EventSource replaces body errors with its own ErrorEvent, losing the original
// error's type and code. Keep the transport's terminal decision on the body so
// the retry owner can still read it after EventSource reports the failure.
const terminalStreams = new WeakSet();
export function markStreamTerminal(body) {
    terminalStreams.add(body);
}
export function isStreamTerminal(body) {
    return body !== null && terminalStreams.has(body);
}
//# sourceMappingURL=terminalStream.js.map